export {default as default} from './Gallery'


// WEBPACK FOOTER //
// ./src/commonUI/photoGallery/index.js